import { useState, useEffect, useCallback } from 'preact/hooks';
import type { AppRoute } from './appRoutes';
import {
  DEFAULT_APP_ROUTE,
  readRouteFromWindow,
  writeRouteToWindow,
} from './appRoutes';

export function useHashRoute() {
  const [route, setRoute] = useState<AppRoute>(() => readRouteFromWindow());

  useEffect(() => {
    if (!window.location.hash || window.location.hash === '#') {
      writeRouteToWindow(DEFAULT_APP_ROUTE, true);
    }

    const onHashChange = () => setRoute(readRouteFromWindow());
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  const navigate = useCallback((next: AppRoute, options?: { replace?: boolean }) => {
    writeRouteToWindow(next, options?.replace);
    setRoute(next);
  }, []);

  return { route, navigate };
}
